import React, { useEffect, useState } from 'react';
import { i18n } from 'fishx';
import { connect } from 'react-redux';

import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

import { Form, Pagination, Spin } from '@whalecloud/fdx';

import { StepFooter, PortalCardList } from '@/components';
import { renderFormItems } from '@/utils';
import { showTotal } from '@/utils/portalDscm';

import { PLAN_DEFAULT_PAGE_SIZE } from './utils';
import styles from './index.module.less';

const SelectPlan = props => {
  const {
    needQuery = true,
    parentInfo = {}, // 父级的列表及分页信息，如果传这个参数，这个组件展示的参数以该传参中的信息为准
    loading = false,
    baseSearchParams = {}, // 基础搜索参数
    offerList, // offer列表
    cardKey = 'offerId',
    defaultOfferId, // 默认选中的offerDetail
    formItems = [], // 父级传过来的表单项
    pageInfo, // 分页信息
    total,
    form: { getFieldDecorator },
    footer = [], // ReactNode 数组，用法与 Model 的类型为 ReactNode 的 footer 相同
    stepFooterDetail = {}, // 与 footer 是二选一 操作
    onSelect,
    qryOfferList,
  } = props;

  const [searchInfo, setSearchInfo] = useState({});
  const handleFormChange = debounce((value, key) => setSearchInfo({
    ...searchInfo,
    [key]: value,
  }), 800);

  const SelectPlanFormItems = [
    ...formItems,
    {
      label: i18n('SELECT_OFFER_PLAN_NAME'),
      name: 'offerName',
      type: 'input',
      formItemCompProps: {
        onChange: e => {
          e.persist();
          const value = get(e, 'target.value');
          handleFormChange(value, 'offerName');
        },
      },
    },
  ];

  useEffect(() => {
    if (!isEmpty(offerList)) {
      onSelect(offerList[0]);
    }
  }, [offerList]);

  const handleOfferListQuery = (page, searchValues) => { // 查询offerList数据
    let params = {
      ...baseSearchParams,
      ...searchValues,
    };
    if (!needQuery && parentInfo.onSearch) { // 主要针对移机、过户的套餐选择
      params = {
        ...params,
        pageInfo: {
          pageIndex: page.currentPage || 1,
          pageCount: PLAN_DEFAULT_PAGE_SIZE,
        },
      };
      parentInfo.onSearch(params);
    } else {
      params = {
        ...params,
        pageInfo: {
          currentPage: 1,
          pageSize: PLAN_DEFAULT_PAGE_SIZE,
          ...page,
        },
      };
      qryOfferList(params);
    }
  };

  useEffect(() => {
    if (needQuery && !isEmpty(baseSearchParams)) {
      handleOfferListQuery();
    }
  }, [needQuery, baseSearchParams]);

  useEffect(() => {
    // 搜索条件
    if (!isEmpty(searchInfo)) {
      handleOfferListQuery({}, searchInfo);
    }
  }, [searchInfo]);

  // 分页查询offer信息
  const handlePageInfoChange = page => {
    const params = {
      ...pageInfo,
      currentPage: page,
    };
    handleOfferListQuery(params, searchInfo); // 查询offerList数据
  };

  const getPlanInfo = () => { // 获取页面展示数据
    if (needQuery) {
      return {
        offerList,
        pageInfo: {
          total: Number(total),
          current: pageInfo.currentPage || 1,
          pageSize: pageInfo.pageSize || PLAN_DEFAULT_PAGE_SIZE,
        },
      };
    }
    return {
      offerList: get(parentInfo, 'offerList'),
      pageInfo: {
        total: Number(get(parentInfo, 'pageInfo.total') || 0),
        current: get(parentInfo, 'pageInfo.pageIndex') || 1,
        pageSize: get(parentInfo, 'pageInfo.pageCount') || PLAN_DEFAULT_PAGE_SIZE,
      },
    };
  };
  return (
    <div className={styles.selectPlan}>
      <Form layout="inline" className={styles.offerForm}>
        <div className="formItemBox">
          {renderFormItems(SelectPlanFormItems, getFieldDecorator)}
        </div>
      </Form>
      <Spin spinning={loading}>
        <div className={styles.OfferContent}>
          <PortalCardList
            cardKey={cardKey}
            dataGroup={getPlanInfo().offerList}
            defaultCardId={defaultOfferId}
            onClick={onSelect}
          />
        </div>
        <div className={styles.footer}>
          {
            getPlanInfo().pageInfo.total > PLAN_DEFAULT_PAGE_SIZE && (
              <div className={styles.pagination}>
                <Pagination
                  showQuickJumper
                  showTotal={showTotal}
                  {...getPlanInfo().pageInfo}
                  onChange={handlePageInfoChange}
                />
              </div>
            )
          }
          {!isEmpty(stepFooterDetail) &&
            <StepFooter
              onPrevious={stepFooterDetail.onPrevious}
              onContinue={stepFooterDetail.onContinue}
              continueContent={stepFooterDetail.continueContent}
              className={styles.footerBtn}
              footer={footer}
            />
          }
        </div>
      </Spin>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  qryOfferList: payload => dispatch({
    type: 'selectPlan/qryOfferList',
    payload,
  }),
});

export default connect(
  ({ selectPlan, loading }) => ({
    loading: loading.effects['selectPlan/qryOfferList'],
    offerList: selectPlan.offerList,
    pageInfo: selectPlan.pageInfo || {},
    total: selectPlan.total,
  }),
  mapDispatchToProps
)(Form.create({ name: 'SELECT_PLAN_FORM' })(SelectPlan));
